import { ReactNode } from 'react';
import { VariantProps } from 'class-variance-authority';
import {
    PropsWithAriaControls,
    PropsWithAriaLabel,
    PropsWithClassName,
    PropsWithCTA,
    PropsWithFontFamily,
    PropsWithIcon,
    PropsWithTestId,
} from '../../../../../src';
import { buttonStyle } from './buttonStyle';
import { iconButtonStyle } from './iconButtonStyle';

export type ButtonBaseProps = PropsWithClassName &
    PropsWithAriaControls &
    PropsWithTestId &
    PropsWithCTA &
    Partial<PropsWithAriaLabel> & {
        fill?: string;
        isCTA?: boolean;
    };

export type ButtonProps = Partial<PropsWithIcon> &
    VariantProps<typeof buttonStyle> &
    Partial<PropsWithFontFamily> & {
        label: string;
        // FIXME: rename to isLoading
        isSpinnerActive?: boolean;
    };

export type IconButtonProps = PropsWithIcon &
    VariantProps<typeof iconButtonStyle> & {
        SkeletonIcon?: ReactNode;
        isLoading?: boolean;
    };

export type GlowButtonProps = ButtonBaseProps & (ButtonProps | IconButtonProps);

export const isButtonProps = (props: ButtonProps | IconButtonProps): props is ButtonProps => {
    return (props as ButtonProps).label !== undefined;
};
